import React, { Fragment } from 'react'

import PropTypes from 'prop-types'

import './component6cards.css'

const Component6cards = (props) => {
  const TitleTag = props.titleAs
  return (
    <div
      className={`component6cards-thq-layout251-elm ${props.rootClassName} `}
    >
      <div className="component6cards-thq-header-component-elm thq-flex-column">
        {props.showComponentTitle === true && (
          <TitleTag className="component6cards-thq-component-title-elm H1_large">
            {props.componentTitle}
          </TitleTag>
        )}
        {props.showComponentText === true && (
          <span className="component6cards-thq-component-text-elm H1_small">
            {props.componentText}
          </span>
        )}
      </div>
      <div className="component6cards-thq-main-content-elm">
        <a
          href={
            typeof props.feature1Url === 'string'
              ? props.feature1Url
              : props.feature1Url?.['url']
          }
          target={props.feature1Url?.['newTab'] ? '_blank' : undefined}
          rel={
            props.feature1Url?.['newTab'] ? 'noreferrer noopener' : undefined
          }
          className="component6cards-prop-link1"
        >
          <div className="component6cards-thq-feature1-elm thq-flex-column">
            <img
              alt={props.feature1ImageAlt}
              src={props.feature1ImageSrc}
              loading="lazy"
              className="component6cards-thq-feature1-image-elm thq-img-ratio-4-3"
            />
            <div className="component6cards-thq-content-elm1">
              <h3 className="H1_extrasmall">{props.feature1Title}</h3>
              <span className="text_medium thq-body-small">
                {props.feature1Description ?? (
                  <Fragment>
                    <span className="component6cards-thq-feature1-description-elm3 thq-body-small">
                      feature1Description
                    </span>
                  </Fragment>
                )}
              </span>
            </div>
          </div>
        </a>
        <a
          href={
            typeof props.feature2Url === 'string'
              ? props.feature2Url
              : props.feature2Url?.['url']
          }
          target={props.feature2Url?.['newTab'] ? '_blank' : undefined}
          rel={
            props.feature2Url?.['newTab'] ? 'noreferrer noopener' : undefined
          }
          className="component6cards-prop-link2"
        >
          <div className="component6cards-thq-feature2-elm thq-flex-column">
            <img
              alt={props.feature2ImageAlt}
              src={props.feature2ImageSrc}
              loading="lazy"
              className="component6cards-thq-feature2-image-elm thq-img-ratio-4-3"
            />
            <div className="component6cards-thq-content-elm2">
              <h3 className="component6cards-thq-feature2-title-elm H1_extrasmall">
                {props.feature2Title}
              </h3>
              <span className="thq-body-small text_medium">
                {props.feature2Description ?? (
                  <Fragment>
                    <span className="component6cards-thq-feature1-description-elm2 thq-body-small">
                      feature2Description
                    </span>
                  </Fragment>
                )}
              </span>
            </div>
          </div>
        </a>
        <a
          href={
            typeof props.feature3Url === 'string'
              ? props.feature3Url
              : props.feature3Url?.['url']
          }
          target={props.feature3Url?.['newTab'] ? '_blank' : undefined}
          rel={
            props.feature3Url?.['newTab'] ? 'noreferrer noopener' : undefined
          }
          className="component6cards-prop-link3"
        >
          <div className="component6cards-thq-feature3-elm thq-flex-column">
            <img
              alt={props.feature3ImageAlt}
              src={props.feature3ImageSrc}
              loading="lazy"
              className="component6cards-thq-feature3-image-elm thq-img-ratio-4-3"
            />
            <div className="component6cards-thq-content-elm3">
              <h3 className="component6cards-thq-feature3-title-elm H1_extrasmall">
                {props.feature3Title}
              </h3>
              <span className="text_medium thq-body-small">
                {props.feature3Description ?? (
                  <Fragment>
                    <span className="component6cards-text2">
                      feature3Description
                    </span>
                  </Fragment>
                )}
              </span>
            </div>
          </div>
        </a>
        <a
          href={
            typeof props.feature4Url === 'string'
              ? props.feature4Url
              : props.feature4Url?.['url']
          }
          target={props.feature4Url?.['newTab'] ? '_blank' : undefined}
          rel={
            props.feature4Url?.['newTab'] ? 'noreferrer noopener' : undefined
          }
          className="component6cards-prop-link4"
        >
          <div className="component6cards-thq-feature4-elm thq-flex-column">
            <img
              alt={props.feature4ImageAlt}
              src={props.feature4ImageSrc}
              loading="lazy"
              className="component6cards-thq-feature4-image-elm thq-img-ratio-4-3"
            />
            <div className="component6cards-thq-content-elm4">
              <h3 className="H1_extrasmall">{props.feature4Title}</h3>
              <span className="text_medium thq-body-small">
                {props.feature4Description ?? (
                  <Fragment>
                    <span className="component6cards-text1">
                      feature4Description
                    </span>
                  </Fragment>
                )}
              </span>
            </div>
          </div>
        </a>
        <a
          href={
            typeof props.feature5Url === 'string'
              ? props.feature5Url
              : props.feature5Url?.['url']
          }
          target={props.feature5Url?.['newTab'] ? '_blank' : undefined}
          rel={
            props.feature5Url?.['newTab'] ? 'noreferrer noopener' : undefined
          }
          className="component6cards-prop-link5"
        >
          <div className="component6cards-thq-feature5-elm thq-flex-column">
            <img
              alt={props.feature5ImageAlt}
              src={props.feature5ImageSrc}
              loading="lazy"
              className="component6cards-thq-feature5-image-elm thq-img-ratio-4-3"
            />
            <div className="component6cards-thq-content-elm5">
              <h3 className="H1_extrasmall">{props.feature5Title}</h3>
              <span className="text_medium thq-body-small">
                {props.feature5Description ?? (
                  <Fragment>
                    <span className="component6cards-text3">
                      feature5Description
                    </span>
                  </Fragment>
                )}
              </span>
            </div>
          </div>
        </a>
        <a
          href={
            typeof props.feature6Url === 'string'
              ? props.feature6Url
              : props.feature6Url?.['url']
          }
          target={props.feature6Url?.['newTab'] ? '_blank' : undefined}
          rel={
            props.feature6Url?.['newTab'] ? 'noreferrer noopener' : undefined
          }
          className="component6cards-prop-link6"
        >
          <div className="component6cards-thq-feature6-elm thq-flex-column">
            <img
              alt={props.feature6ImageAlt}
              src={props.feature6ImageSrc}
              loading="lazy"
              className="component6cards-thq-feature6-image-elm thq-img-ratio-4-3"
            />
            <div className="component6cards-thq-content-elm6">
              <h3 className="H1_extrasmall">{props.feature6Title}</h3>
              <span className="text_medium thq-body-small">
                {props.feature6Description ?? (
                  <Fragment>
                    <span className="component6cards-text4">
                      feature6Description
                    </span>
                  </Fragment>
                )}
              </span>
            </div>
          </div>
        </a>
      </div>
    </div>
  )
}

Component6cards.defaultProps = {
  feature4Description: undefined,
  feature1Url: {
    url: '',
    newTab: false,
  },
  rootClassName: '',
  feature6ImageSrc: 'feature6ImageSrc',
  feature6Title: 'feature6Title',
  feature5Url: {
    url: '',
    newTab: false,
  },
  feature5Title: 'feature5Title',
  feature4Title: 'feature4Title',
  feature5ImageSrc: 'feature5ImageSrc',
  feature2Description: undefined,
  feature1Title: 'feature1Title',
  feature4Url: {
    url: '',
    newTab: false,
  },
  showComponentTitle: true,
  feature2ImageSrc: 'feature2ImageSrc',
  feature4ImageSrc: 'feature4ImageSrc',
  feature6Url: {
    url: '',
    newTab: false,
  },
  feature3Url: {
    url: '',
    newTab: false,
  },
  componentText: 'componentText',
  feature3Title: 'feature3Title',
  feature1Description: undefined,
  feature3ImageSrc: 'feature3ImageSrc',
  componentTitle: 'componentTitle',
  showComponentText: true,
  feature1ImageSrc: 'feature1Image',
  feature3Description: undefined,
  feature2Title: 'feature2Title',
  feature5Description: undefined,
  feature2Url: {
    url: '',
    newTab: false,
  },
  feature6Description: undefined,
  titleAs: 'h2',
  feature1ImageAlt: '',
  feature2ImageAlt: '',
  feature3ImageAlt: '',
  feature4ImageAlt: '',
  feature5ImageAlt: '',
  feature6ImageAlt: '',
}

Component6cards.propTypes = {
  feature4Description: PropTypes.element,
  feature1Url: PropTypes.object,
  rootClassName: PropTypes.string,
  feature6ImageSrc: PropTypes.string,
  feature6Title: PropTypes.string,
  feature5Url: PropTypes.object,
  feature5Title: PropTypes.string,
  feature4Title: PropTypes.string,
  feature5ImageSrc: PropTypes.string,
  feature2Description: PropTypes.element,
  feature1Title: PropTypes.string,
  feature4Url: PropTypes.object,
  showComponentTitle: PropTypes.bool,
  feature2ImageSrc: PropTypes.string,
  feature4ImageSrc: PropTypes.string,
  feature6Url: PropTypes.object,
  feature3Url: PropTypes.object,
  componentText: PropTypes.string,
  feature3Title: PropTypes.string,
  feature1Description: PropTypes.element,
  feature3ImageSrc: PropTypes.string,
  componentTitle: PropTypes.string,
  showComponentText: PropTypes.bool,
  feature1ImageSrc: PropTypes.string,
  feature3Description: PropTypes.element,
  feature2Title: PropTypes.string,
  feature5Description: PropTypes.element,
  feature2Url: PropTypes.object,
  feature6Description: PropTypes.element,
  titleAs: PropTypes.string,
  feature1ImageAlt: PropTypes.string,
  feature2ImageAlt: PropTypes.string,
  feature3ImageAlt: PropTypes.string,
  feature4ImageAlt: PropTypes.string,
  feature5ImageAlt: PropTypes.string,
  feature6ImageAlt: PropTypes.string,
}

export default Component6cards
